<template>
    <div>
        <div class="layui-card-header">
            <blockquote class="layui-elem-quote">
                职业标准
            </blockquote>
        </div>

        <div class="layui-card-body" style="height: 550px;margin-top: 20px;width: 910px;">

            <el-select v-model="workTypeId" placeholder="请选择">
                <el-option v-for="item in workTypeList" :key="item.workTypeId" :label="item.workTypeName"
                    :value="item.workTypeId">
                </el-option>
            </el-select>

            <el-button icon="el-icon-search" circle style="margin-left: 30px;" @click="search"></el-button>

            <el-table :data="tableData" style="width: 100%;height: 526px;overflow-y: scroll;margin-top: 30px;">
                <el-table-column align="center" label="序号" width="170" type="index">
                </el-table-column>
                <el-table-column align="center" label="工种名称" width="280">
                    <template slot-scope="scope">
                        <span>{{ scope.row.workTypeName }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="工种编号" width="280">
                    <template slot-scope="scope">
                        <span>{{ scope.row.workTypeNum }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="170">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="examine1(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>

        <el-dialog :title='nameOfPayingJob' :visible.sync="dialogTableVisible2" style="margin-top: 0vh;height: auto"
            :center="true">

            <iframe v-if="pdfFlag" :src="src" style="width: 99%;height: 100%;">
            </iframe>

            <img v-if="imgFlag" :src="src" width="100%" height="100%"></img>

            <div v-if="standardDescFlag" v-html="standardDesc"></div>

            <span v-if="flag">该工种暂无职业标准</span>

        </el-dialog>

    </div>
</template>

<script>

    import pdf from 'vue-pdf'
    export default {
        name: 'app',
        components: {
        },
        data() {
            return {
                dialogTableVisible2: false,
                workTypeId: '',
                workTypeList: [],
                flag: false,
                nameOfPayingJob: '',
                pdfFlag: false,
                imgFlag: false,
                standardDescFlag: false,
                tableData: [],
                src: '', // pdf文件地址
                standardDesc: ''
            }
        },
        created() {
            this.loadData();
        },
        mounted() {

        },
        methods: {
            //搜索    
            search() {
                if (this.workTypeId === 0) {
                    this.$message({
                        message: '请选择工种后再查询！',
                        type: 'warning'
                    });
                    return false;
                } else {
                    let parames = new URLSearchParams();
                    parames.append('organStatus', this.organStatus);
                    parames.append('userType', 1);
                    parames.append('workTypeId', this.workTypeId);

                    //获取 当前等级下的上传资料 列表
                    this.$axios.post(this.serverUrl + '/dict/getGroupList', parames).then(resp => {
                        if (resp.data.code === '4001') {

                            this.$message({
                                showClose: true,
                                message: '请求过于频繁,于一分钟后重试！',
                                type: 'error'
                            })

                        } else if (resp.data.code === '4000' || resp.data.code === '4002' || resp.data.code === '4003') {
                            this.$confirm('登录超时！请重新登录').then(_ => {
                                this.$router.push('/login');
                            }).catch(_ => { });
                        } else {
                            if (resp.data.code === 1) {
                                let ArrayList = [];
                                resp.data.data.forEach(element => {

                                    let GroupWorkTypeVo = {
                                        workTypeId: '',//工种id
                                        workTypeName: '',//职业|工种名称
                                        workTypeNum: '',//职业|工种b编号
                                        groupId: '', //组织id
                                        groupType: 0, //组织类型 1.学校 2.社会
                                        registrationreStatus: 0 //报名状态 1可报名2预报名3隐藏
                                    };

                                    GroupWorkTypeVo.workTypeId = element.workTypeId;
                                    GroupWorkTypeVo.workTypeName = element.workTypeName;
                                    GroupWorkTypeVo.workTypeNum = element.workTypeNum;
                                    GroupWorkTypeVo.groupId = element.groupId;
                                    GroupWorkTypeVo.groupType = element.groupType;
                                    GroupWorkTypeVo.registrationreStatus = element.registrationreStatus;  //报名状态

                                    ArrayList.push(GroupWorkTypeVo);
                                });
                                this.tableData = ArrayList;
                            }
                        }


                    }).catch(err => {


                    })
                }


            },
            //查看某工种的 pdf
            examine1(row) {
                this.nameOfPayingJob = row.workTypeName;

                let parames = new URLSearchParams();
                parames.append('workTypeId', row.workTypeId);
                parames.append('levelState', this.$route.params.workTypeLevelState);
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/dict/getDictWorkTypeStandard', parames).then(resp => {
                    if (resp.data.code === 1) {
                        let ArrayList = [];
                        this.dialogTableVisible2 = true;
                        if (resp.data.data.length != 0) {

                            if (resp.data.data[0].standardType === 1) {
                                //图片
                                this.pdfFlag = false;
                                this.flag = false;
                                this.imgFlag = true;
                                this.standardDescFlag = false;

                                this.src = resp.data.data[0].standardDesc;

                            } else if (resp.data.data[0].standardType === 2) {
                                //富文本
                                this.pdfFlag = false;
                                this.flag = false;
                                this.imgFlag = false;
                                this.standardDescFlag = true;

                                this.standardDesc = resp.data.data[0].standardDesc;

                            } else if (resp.data.data[0].standardType === 3) {
                                //pdf
                                this.pdfFlag = true;
                                this.flag = false;
                                this.imgFlag = false;
                                this.standardDescFlag = false;

                                this.src = this.serverUrl + this.prefiexUrl + resp.data.data[0].standardDesc;

                                console.log(this.src);
                            }

                        } else {
                            this.pdfFlag = false;
                            this.imgFlag = false;
                            this.standardDescFlag = false;
                            this.flag = true;
                        }

                    }
                }).catch(err => {

                })

            },
            //初始化数据
            loadData() {
                let parames = new URLSearchParams();
                parames.append('organStatus', this.organStatus);
                parames.append('userType', 1);
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/dict/getGroupList', parames).then(resp => {
                    if (resp.data.code === 1) {
                        let ArrayList = [];
                        let workTypeList = [];
                        resp.data.data.forEach(element => {

                            let GroupWorkTypeVo = {
                                workTypeId: '',//工种id
                                workTypeName: '',//职业|工种名称
                                workTypeNum: '',//职业|工种b编号
                                groupId: '', //组织id
                                groupType: 0, //组织类型 1.学校 2.社会
                                registrationreStatus: 0 //报名状态 1可报名2预报名3隐藏
                            };

                            GroupWorkTypeVo.workTypeId = element.workTypeId;
                            GroupWorkTypeVo.workTypeName = element.workTypeName;
                            GroupWorkTypeVo.workTypeNum = element.workTypeNum;
                            GroupWorkTypeVo.groupId = element.groupId;
                            GroupWorkTypeVo.groupType = element.groupType;
                            GroupWorkTypeVo.registrationreStatus = element.registrationreStatus; //报名状态

                            ArrayList.push(GroupWorkTypeVo);

                            let workType = {
                                workTypeId: '',//工种id
                                workTypeName: '',//职业|工种名称
                            };
                            workType.workTypeId = element.workTypeId;
                            workType.workTypeName = element.workTypeName;

                            workTypeList.push(workType);

                        });
                        this.tableData = ArrayList;
                        this.workTypeList = workTypeList;
                    }
                }).catch(err => {


                })
            },

        }

    }
</script>

<style scoped>
    div /deep/ .el-dialog__body {
        height: 650px !important;
        padding: 30px 20px;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
    }

    div /deep/ .el-dialog {
        position: relative;
        margin: 0 auto 50px;
        border-radius: 2px;
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
        box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 70%;
        height: 700px !important;
        /* height: 650px; */
        /* overflow: scroll; */
        margin-top: 5vh !important;
    }

    .el-dialog--center .el-dialog__body {
        text-align: initial;
        /* padding: 25px 25px 30px; */
        height: 600px;
    }

    .el-table td,
    .el-table th {
        padding: 12px 0;
        min-width: 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        text-overflow: ellipsis;
        vertical-align: middle;
        position: relative;
        text-align: center;
    }

    .layui-input-inline {
        display: inline-block;
        vertical-align: middle;
    }

    .layui-form-item .layui-input-inline {
        float: left;
        width: 190px;
        margin-right: 10px;
    }

    .layui-form-label {
        min-width: 114px;
        width: auto;
        float: left;
        display: block;
        padding: 9px 15px;
        width: 80px;
        font-weight: 400;
        line-height: 20px;
        text-align: right;
    }

    .layui-form-item {
        margin-bottom: 15px;
        clear: both;
        *zoom: 1;
    }

    .w-580 {
        width: 580px;
        margin: 0 auto;
        position: relative;
    }

    .layui-card-body {
        position: relative;
        padding: 10px 15px;
        line-height: 24px;
    }

    .layui-card-header {
        position: relative;
        height: 42px;
        line-height: 42px;
        padding: 0 15px;
        border-bottom: 1px solid #f6f6f6;
        color: #333;
        border-radius: 2px 2px 0 0;
        font-size: 14px;
    }

    .u-gx-ttop {
        border-bottom: none;
        margin: 0 15px;
        height: 38px;
        padding: 10px 0;
    }

    .f-fc9 {
        color: #999;
    }

    .f-f0 {
        font-family: "Arial", "Hiragino Sans GB", \5fae\8f6f\96c5\9ed1, "Helvetica", "sans-serif";
    }

    .f-fl {
        float: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/affirm/affirmProfessionalStandard.vue